import type { ComponentProps, FC } from 'react';
import { SvgIcon } from './SvgIcon';
type Props = ComponentProps<typeof SvgIcon>;

const KeyOutlinedSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M25.329 2.70844C20.1428 2.70844 15.9235 6.92767 15.9235 12.1139C15.9235 14.161 16.5813 16.0571 17.6961 17.6029L12.2881 23.0109L7.93444 18.6572C7.80188 18.5246 7.58696 18.5246 7.4544 18.6572L5.77075 20.3409C5.6382 20.4735 5.63821 20.6884 5.77076 20.821L10.1244 25.1746L7.76025 27.5388L3.47428 23.2528C3.34173 23.1202 3.1268 23.1202 2.99425 23.2528L1.31059 24.9365C1.17804 25.0691 1.17804 25.284 1.3106 25.4166L5.59652 29.7025L4.23619 31.0629C4.10364 31.1954 4.10363 31.4103 4.23618 31.5429L5.91983 33.2266C6.05239 33.3592 6.26731 33.3592 6.39987 33.2266L19.8629 19.7635C21.4045 20.8682 23.2921 21.5193 25.329 21.5193C30.5152 21.5193 34.7345 17.3 34.7345 12.1139C34.7345 6.92767 30.5152 2.70844 25.329 2.70844ZM25.329 18.4594C21.8301 18.4594 18.9835 15.6128 18.9835 12.1139C18.9835 8.61498 21.8301 5.7684 25.329 5.7684C28.8279 5.7684 31.6745 8.61498 31.6745 12.1139C31.6745 15.6128 28.8279 18.4594 25.329 18.4594Z" />
  </svg>
);

export const KeyOutlinedIcon: FC<Props> = (props) => {
  return <SvgIcon component={KeyOutlinedSvg} {...props} />;
};
